import React, { Component } from 'react';
import { connect } from 'react-redux';

import classes from './Modal.css';
import Aux from '../../../hoc/Aux/Aux';
import Backdrop from '../Backdrop/Backdrop'
import { LogoLoader } from '../Loader/LogoLoader';

import Plus from '../Icons/Plus';


class Modal extends Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.show !== this.props.show || nextProps.children !== this.props.children;
  }

  render() {
    let modalStyle = classes.Modal;
    if (this.props.isSmall) {
      modalStyle = [classes.Modal, classes.Small].join(' ')
    }
    if (this.props.isFitToContent) {
      modalStyle = classes.ModalFitToContent;
    }
    if (this.props.isFullScreen) {
      modalStyle = [classes.Modal, classes.ModalFullScreen].join(' ');
    }
    if (this.props.isFullScreenNarrow) {
      modalStyle = [classes.Modal, classes.ModalFullScreenNarrow].join(' ');
    }

    let content = null;
    if (this.props.show && this.props.isLoader) {
      content = <div className={classes.LogoLoader}>
        <p style={{ color: 'white', textAlign: 'center', margin: 0, fontSize: '20px' }}>{this.props.translations.label_loading}</p>
        <LogoLoader />
      </div>
    } else if (this.props.show) {
      content = <div className={modalStyle}>
        {this.props.closeIconCallback && <div className={classes.ModalHeader}>
          <div className={classes.CloseContainer} onClick={this.props.closeIconCallback}>
            <div className={classes.CloseIconContainer}>
              <Plus />
            </div>
          </div>
        </div>}
        {this.props.children}
      </div>
    }

    return (
      <Aux>
        <Backdrop show={this.props.show} clicked={this.props.dismissable ? this.props.modalClosed : () => { }} />
        {content}
      </Aux>
    );
  }
}

const mapStateToProps = state => ({ translations: state.settingsReducer.translations });

export default connect(mapStateToProps)(Modal);


// WEBPACK FOOTER //
// ./src/components/UI/Modal/Modal.js